export const config = {
  apiUrl:
    window.location.href.toLowerCase().indexOf("http://localhost:3000") >= 0
      ? "https://localhost:44324/api/"
      : "api/",
  // apiUrl: 'api/'
};



// WEBPACK FOOTER //
// ./src/helpers/configs.js